import { Trans } from '@lingui/react'

import { PRESCRIPTION_TYPE_NO_PRESCRIPTION } from 'shared/consts/productTemplates'
import DeliveryDatesForMarketplace from 'shared/experiments/components/DeliveryDatesForMarketplace'
import DeliveryDatesForOtc from 'shared/experiments/components/DeliveryDatesForOtc'
import {
  DISPLAYING_DELIVERY_DATES_FOR_MARKETPLACE,
  DISPLAYING_DELIVERY_DATES_FOR_OTC,
} from 'shared/experiments/consts'
import { useGetExperiment } from 'shared/experiments/utils/experiments'

export const useGetAvailabilityTranslation = ({
  available,
  productType,
  isMarketplaceProduct,
  deliveryTime,
}: {
  available: boolean
  productType: string
  isMarketplaceProduct: boolean
  deliveryTime?: { earliestDays?: number; latestDays?: number } | null
}) => {
  // Only OTC and OTX products that are not MP
  const isOTProduct =
    productType === PRESCRIPTION_TYPE_NO_PRESCRIPTION && !isMarketplaceProduct

  // Get the delivery dates experiment state (same as ProductInfo)
  const deliveryDatesExperiment = useGetExperiment(
    DISPLAYING_DELIVERY_DATES_FOR_OTC
  )
  const deliveryDatesForMarketplaceExperiment = useGetExperiment(
    DISPLAYING_DELIVERY_DATES_FOR_MARKETPLACE
  )

  let contentToRender

  if (!available) {
    contentToRender = <Trans id="general.label.product.currentlyNotAvailable" />
  } else if (deliveryDatesExperiment?.isEnabled && isOTProduct && available) {
    contentToRender = (
      <DeliveryDatesForOtc experiment={deliveryDatesExperiment} />
    )
  } else if (
    deliveryDatesForMarketplaceExperiment?.isEnabled &&
    isMarketplaceProduct &&
    available
  ) {
    contentToRender = (
      <DeliveryDatesForMarketplace
        experiment={deliveryDatesForMarketplaceExperiment}
        deliveryTime={deliveryTime}
      />
    )
  } else {
    contentToRender = <Trans id="general.label.product.available" />
  }

  return contentToRender
}
